import React, { useEffect, useState } from "react";
import { A, aa } from "../theme/palette";

// Аватар пользователя панели: загруженное фото (или подтянутое из Telegram),
// а без него — первые две буквы логина на акцентной плашке. Если картинка не
// загрузилась (удалили на сервере, сеть), тоже показываются буквы.
const UserAvatar = ({ username = "", avatarUrl = "", size = 34, radius = 10, fontSize = 12, isDarkTheme = true, style }) => {
  const [failedUrl, setFailedUrl] = useState("");
  useEffect(() => { setFailedUrl(""); }, [avatarUrl]);
  const showImage = Boolean(avatarUrl) && failedUrl !== avatarUrl;
  return (
    <span
      className="kl-user-avatar"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${radius}px`,
        flexShrink: 0,
        overflow: "hidden",
        background: showImage ? "transparent" : aa(500, 0.16),
        border: showImage ? "none" : `1px solid ${aa(500, 0.3)}`,
        color: isDarkTheme ? A[300] : A[600],
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: `${fontSize}px`,
        fontWeight: 700,
        boxSizing: "border-box",
        ...style
      }}
    >
      {showImage ? (
        <img
          src={avatarUrl}
          alt=""
          draggable={false}
          onError={() => setFailedUrl(avatarUrl)}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      ) : String(username || "U").trim().slice(0, 2).toUpperCase()}
    </span>
  );
};

export default UserAvatar;
